<script lang="ts">
	import { Router, Route, Link } from "svelte-routing";
	import Home from "./routes/Home.svelte";
	import Ascii2hex from "./routes/Ascii2hex.svelte";
	import Hex2ascii from "./routes/Hex2ascii.svelte";
	import Navmenu from "./components/Navmenu.svelte"

	// Used for SSR. A falsy value is ignored by the Router.
	export let url : string = "";

    let MenuParams : string = "navbar-menu";
    let BurgerParams : string = "navbar-burger";
    let IsVisible : boolean = false;

    function SetIsVisible() : void
    {
        MenuParams = "navbar-menu is-active";
        BurgerParams = "navbar-burger is-active";
    }

    function SetNotVisible() : void
    {
        MenuParams = "navbar-menu";
        BurgerParams = "navbar-burger";
    }

    function OnBurgerClick() : void
    {
        console.log("OnBurgerClick");

        IsVisible = !IsVisible;

        if (IsVisible)
        {
            SetIsVisible();
        }
        else
        {
            SetNotVisible();
        }

        console.log(MenuParams);
        console.log(BurgerParams);
    }

</script>



<Router url="{url}">
	<nav class="navbar" role="navigation" aria-label="main navigation">
		<div class="navbar-brand">
			<a class="navbar-item" href="/" style="color:red;">
			ASCIIUTILS.COM
			</a>

			<a role="button" class="{BurgerParams}" aria-label="menu" aria-expanded="false" data-target="#navMenu" on:click="{OnBurgerClick}">
			<span aria-hidden="true"></span>
			<span aria-hidden="true"></span>
			<span aria-hidden="true"></span>
			</a>
		</div>

		<div id="navMenu" class="{MenuParams}" >
			<div class="navbar-start">
				<div class="navbar-item">
					<Link to="/" >ASCII Table</Link>
				</div>
				<div class="navbar-item">
					<Link to="ascii2hex" >ASCII to HEX Buffer</Link>
				</div>
				<div class="navbar-item">
					<Link to="hex2ascii" >HEX Buffer to ASCII</Link>
				</div>
			</div>

		</div>
	</nav>

	<section class="section">
		<div class="container is-fullwidth">

			<div class="columns">
				<div class="column">
					<Route path="ascii2hex" component="{Ascii2hex}" />
					<Route path="hex2ascii" component="{Hex2ascii}" />
					<Route path="/" component="{Home}" />
				</div>
			</div>
		</div>
	</section> 
</Router>
